import store from "../store/index";
import CookieHelpers from "../helpers/CookieHelpers";
import { INTERACTIONS_ATTACHMENT_UPLOAD } from "../constants/urls";

function uploadTypeForMime(mime, filename) {
  const m = (mime || "").toLowerCase();
  const n = (filename || "").toLowerCase();
  if (m.startsWith("image/")) return "image";
  if (m.startsWith("video/")) return "video";
  if (m.startsWith("audio/")) return "audio";
  if (m === "application/pdf" || n.endsWith(".pdf")) return "pdf";
  if (n.match(/\.(docx?|odt|rtf)$/)) return "document";
  if (n.match(/\.(xlsx?|csv|ods)$/)) return "spreadsheet";
  if (n.match(/\.(pptx?|odp)$/)) return "presentation";
  return "file";
}

function unwrapPayload(body) {
  if (!body) return null;
  if (typeof body !== "object") return null;
  return body.payload;
}

export function uploadFile(file, onProgress, opts) {
  const { entity, type } = opts || {};
  if (!entity) {
    return Promise.reject(new Error("uploadFile: opts.entity is required (backend rejects empty Entity)."));
  }
  const apiURL = store.state.appState.apiURL;
  const token = CookieHelpers.getCookie("token");

  let xhr = null;
  let cancelled = false;

  const promise = new Promise((resolve, reject) => {
    xhr = new XMLHttpRequest();

    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && typeof onProgress === "function") {
        onProgress(Math.round((e.loaded / e.total) * 100), e.loaded, e.total);
      }
    };

    xhr.onload = () => {
      if (cancelled) return;
      const ok = xhr.status >= 200 && xhr.status < 300;
      let body = null;
      try { body = xhr.responseText ? JSON.parse(xhr.responseText) : null; }
      catch (_) { body = xhr.responseText; }

      if (!ok) {
        reject(new Error(`Upload failed (${xhr.status})`));
        return;
      }

      const payload = unwrapPayload(body);
      if (!payload || payload.id == null) {
        reject(new Error("Upload returned no attachment ID."));
        return;
      }

      resolve({
        id: payload.id,
        fileURL: payload.fileURL,
        fileName: payload.fileName,
        mimeType: payload.mimeType,
        fileSizeBytes: payload.fileSizeBytes,
        createdAt: payload.createdAt,
      });
    };

    xhr.onerror = () => {
      if (cancelled) return;
      reject(new Error("Network error"));
    };
    xhr.onabort = () => reject(Object.assign(new Error("aborted"), { cancelled: true }));

    const formData = new FormData();
    formData.append("Entity", entity);
    formData.append("Type", type || uploadTypeForMime(file.type, file.name));
    formData.append("File", file, file.name);
    formData.append("IsCompressionRequired", "false");

    xhr.open("POST", `${apiURL}${INTERACTIONS_ATTACHMENT_UPLOAD}`);
    xhr.setRequestHeader("AuthToken", "System123");
    if (token) xhr.setRequestHeader("Authorization", `Bearer ${token}`);
    xhr.send(formData);
  });

  promise.cancel = () => {
    cancelled = true;
    if (xhr) try { xhr.abort(); } catch (_) { }
  };
  return promise;
}

